import { createSlice } from "@reduxjs/toolkit";
import type { RootState } from "../app";

// Define a type for the slice state
interface typeState {
  type: string;
  loadurl: string;
  chaturl: string;
  geturl: string;
  showSecondary: boolean;
  list_of_files: any[];
  prompt_storage: string;
  prompts: string[];
  uploadtypes: string[];
  deleteurl: string;
  loaddb: string;
  userFormats: string[];
  userPrompt: string;
  datapreviewurl: string;
  shortname: string;
  shared_files: string[];
  mode: string[];
}

// interface i_image {
//   base64_string: string;
//   filename: string;
// }

// Define the initial state using that type
const initialState: typeState = {
  type: "",
  loadurl: "",
  chaturl: "",
  geturl: "",
  showSecondary: false,
  list_of_files: [],
  prompt_storage: "",
  prompts: [],
  uploadtypes: [],
  userFormats: [],
  deleteurl: "",
  loaddb: "",
  userPrompt: "",
  datapreviewurl: "",
  shortname: "",
  shared_files: [],
  mode: ["chat"],
};

export const typeSlice = createSlice({
  name: "type",
  // `createSlice` will infer the state type from the `initialState` argument
  initialState,
  reducers: {
    addType: (state, action) => {
      state.chaturl = action.payload.chaturl;
      state.loadurl = action.payload.loadurl;
      state.type = action.payload.name;
      state.geturl = action.payload.geturl;
      state.showSecondary = action.payload.showSecondary;
      state.prompt_storage = action.payload.prompt_storage;
      state.uploadtypes = action.payload.uploadtypes;
      state.deleteurl = action.payload.deleteurl;
      state.loaddb = action.payload.loaddb;
      state.userPrompt = "";
      state.datapreviewurl = action.payload.datapreviewurl;
      state.shortname = action.payload.shortname;
      state.mode = action.payload.mode;
    },
    addFiles: (state, action) => {
      return {
        ...state,
        showSecondary: true,
        list_of_files: action.payload,
      };
    },
    addPrompts: (state, action) => {
      return {
        ...state,
        showSecondary: true,
        prompts: action.payload,
      };
    },
    addUserFormats: (state, action) => {
      return {
        ...state,
        showSecondary: true,
        userFormats: action.payload,
      };
    },
    addUserFormatPrompt: (state, action) => {
      return {
        ...state,
        userPrompt: action.payload,
      };
    },
    removeType: () => {
      return {
        ...initialState,
      };
    },
    addSharedFiles: (state, action) => {
      return {
        ...state,
        shared_files: action.payload,
      };
    },
  },
});

export const {
  addType,
  addFiles,
  addPrompts,
  addUserFormats,
  addUserFormatPrompt,
  removeType,
  addSharedFiles,
} = typeSlice.actions;

// Other code such as selectors can use the imported `RootState` type
export const getType = (state: RootState) => state.type;
export const getShowSecondary = (state: RootState) => state.type.showSecondary;
export const getFiles = (state: RootState) => state.type.list_of_files;
export const getPrompts = (state: RootState) => state.type.prompts;
export const getUserFormats = (state: RootState) => state.type.userFormats;
export const getUserFormatPrompt = (state: RootState) => state.type.userPrompt;
export const getSharedDocuments = (state: RootState) => state.type.shared_files;

export default typeSlice.reducer;
